import React from 'react';
import RoleView from './RoleView';
import { useNavigate, useLocation } from 'react-router-dom';
import { FaSignOutAlt } from 'react-icons/fa';

const Sidebar = ({ sidebarVisible, setSidebarVisible }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const isActive = (path) => location.pathname === path;

  const logout = () => {
    localStorage.removeItem('user');
    navigate('/', { replace: true });
  };

  const styles = {
    sidebar: {
      width: '190px',
      height: '100vh',               // 👈 altura fija para ocupar todo el viewport
      overflowY: 'auto',             // 👈 scroll interno si el contenido excede
      background: 'linear-gradient(180deg, #1f3339 0%, #30cfcf 100%)',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-start',  // 👈 evita huecos verticales
      alignItems: 'center',
      position: 'fixed',
      left: sidebarVisible ? 0 : '-190px',
      top: 0,
      color: '#fff',
      zIndex: 999,
      fontFamily: "'Poppins', sans-serif",
      transition: 'left 0.3s ease-in-out',
    },
    logo: {
      width: '190px',
      display: 'block',
      height: '73px',
      margin: 0,
    },
    nav: {
      listStyle: 'none',
      padding: 0,
      margin: 0,
      width: '100%',
      flex: 1,
      marginTop: '2.5rem',
    },
    linkBox: {
      width: '100%',
      textAlign: 'center',
      transition: 'all 0.3s ease',
    },
    linkBoxActive: {
      backgroundColor: 'rgba(255,255,255,0.25)',
      borderRadius: '8px',
    },
    link: {
      display: 'block',
      color: '#fff',
      textDecoration: 'none',
      padding: '0.8rem 0',
      fontWeight: 600,
      lineHeight: 4,
      transition: 'all 0.3s ease',
    },
    footer: {
      width: '100%',
      textAlign: 'center',
      padding: '1rem 0',
      borderTop: '1px solid rgba(255, 255, 255, 0.3)',
      marginTop: 'auto',             // 👈 empuja el footer al fondo sin hueco extra
    },
    logoutBtn: {
      background: 'none',
      border: 'none',
      color: '#fff',
      cursor: 'pointer',
      fontWeight: 600,
      fontSize: '0.95rem',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '6px',
      padding: '0.5rem 0',
      borderRadius: '8px',
      width: '100%',
      transition: 'background 0.3s ease',
    },
      icon: {
      marginRight: '0.5rem',
      fontSize: '1.4rem',
      verticalAlign: 'middle',
    },
    closeBtn: {
      alignSelf: 'flex-end',
      margin: '1rem',
      background: 'none',
      border: 'none',
      color: '#fff',
      fontSize: '1.5rem',
      cursor: 'pointer',
    },
  };

  return (
    <aside style={styles.sidebar}>
      {window.innerWidth < 768 && (
        <button onClick={() => setSidebarVisible(false)} style={styles.closeBtn}>
          ✕
        </button>
      )}

      <div>
        <img src="/logoVidaSalud.png" alt="Logo Vida-Salud" style={styles.logo} />
      </div>

      <ul style={styles.nav}>
        {[
          { path: '/insumos', label: 'Insumos' },
          { path: '/reactivos', label: 'Reactivos' },
          { path: '/consumibles', label: 'Consumibles' },
          { path: '/historial', label: 'Movimientos' },
        ].map(({ path, label }) => (
          <li
            key={path}
            style={{
              ...styles.linkBox,
              ...(isActive(path) ? styles.linkBoxActive : {}),
            }}
            onMouseEnter={(e) =>
              (e.currentTarget.style.backgroundColor = 'rgba(255,255,255,0.15)')
            }
            onMouseLeave={(e) => {
              if (!isActive(path)) e.currentTarget.style.backgroundColor = 'transparent';
            }}
          >
            <a href={path} style={styles.link}>
              {label}
            </a>
          </li>
        ))}

        <RoleView allowedRole="admin">
          <li
            style={{
              ...styles.linkBox,
              ...(isActive('/usuarios') ? styles.linkBoxActive : {}),
            }}
            onMouseEnter={(e) =>
              (e.currentTarget.style.backgroundColor = 'rgba(255,255,255,0.15)')
            }
            onMouseLeave={(e) => {
              if (!isActive('/usuarios')) e.currentTarget.style.backgroundColor = 'transparent';
            }}
          >
            <a href="/usuarios" style={styles.link}>
              Usuarios
            </a>
          </li>
        </RoleView>
      </ul>

    <div style={styles.footer}>
      <button
        onClick={logout}
        style={styles.logoutBtn}
        onMouseEnter={(e) =>
          (e.currentTarget.style.backgroundColor = 'rgba(255,255,255,0.15)')
        }
        onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = 'transparent')}
      >
        <FaSignOutAlt style={styles.icon} />
        Cerrar sesión
      </button>
    </div>
    </aside>
  );
};

export default Sidebar;
